import React from 'react';
import styles from './Common.module.css'


export function renderRLHeader() {
    return (
        <div className={styles.row}>
            <span className={styles.flag} />
            <span className={styles.spacer} />
            <span className={styles.label} />
            <span className={styles.r_header}>R</span>
            <span className={styles.c_header} />
            <span className={styles.l_header}>L</span>
        </div>
    );
}

export function renderRLWideHeader() {
    return (
        <div className={styles.row}>
            <span className={styles.flag} />
            <span className={styles.spacer} />
            <span className={styles.label} />
            <span className={styles.r_wide_header}>R</span>
            <span className={styles.c_header} />
            <span className={styles.l_wide_header}>L</span>
        </div>
    );
}

export function renderOpenClosedHeader() {
    return (
        <div className={styles.row}>
            <span className={styles.flag} />
            <span className={styles.spacer} />
            <span className={styles.label} />
            <span className={styles.r_header}>Open</span>
            <span className={styles.c_header} />
            <span className={styles.l_header}>Closed</span>
        </div>
    );
}
